<button type="button" class="auth-select__trigger" [id]="selectId" [disabled]="disabled" [class.is-invalid]="invalid"
  role="combobox" aria-haspopup="listbox" [attr.aria-expanded]="open" [attr.aria-label]="ariaLabel || null"
  (click)="toggle()" (keydown)="onKeydown($event)">
  @if (selected?.icon) { <span class="auth-select__icon" [class]="selected!.icon" aria-hidden="true"></span> }
  @if (selected?.iconUrl) { <img class="auth-select__flag" [src]="selected!.iconUrl" alt="" aria-hidden="true"> }
  <span class="auth-select__label" [class.auth-select__label--placeholder]="!selectedLabel">{{ selectedLabel || placeholder }}</span>
  <i class="far fa-chevron-down auth-select__chevron" [class.auth-select__chevron--open]="open" aria-hidden="true"></i>
</button>

@if (open) {
  <ul class="auth-select__panel" role="listbox">
    @if (searchable) {
      <li class="auth-select__search">
        <!-- keydown.stop: las flechas y Enter los gestiona el trigger; sin esto
             el input se los quedaría y el teclado dejaría de recorrer la lista. -->
        <i class="far fa-search" aria-hidden="true"></i>
        <input type="text" [placeholder]="searchPlaceholder" [value]="query" autocomplete="off"
          (input)="onSearch($any($event.target).value)" (keydown)="onKeydown($event)"
          (mousedown)="$event.stopPropagation()">
      </li>
    }
    @for (option of visibleOptions; track option.value; let i = $index) {
      <li>
        <!-- mousedown.preventDefault: que el clic no robe el foco del trigger,
             o el panel se cerraría antes de registrar la selección. -->
        <button type="button" class="auth-select__option" role="option"
          [attr.aria-selected]="option.value === value" [class.auth-select__option--active]="i === activeIndex"
          (mousedown)="$event.preventDefault()" (mouseenter)="activeIndex = i" (click)="select(option)">
          <span class="auth-select__check" aria-hidden="true">@if (option.value === value) { <i class="far fa-check"></i> }</span>
          @if (option.icon) { <span class="auth-select__icon" [class]="option.icon" aria-hidden="true"></span> }
          @if (option.iconUrl) { <img class="auth-select__flag" [src]="option.iconUrl" alt="" aria-hidden="true"> }
          <span class="auth-select__option-label">{{ option.label }}</span>
        </button>
      </li>
    }
    @if (!visibleOptions.length) { <li class="auth-select__empty">{{ emptyLabel }}</li> }
  </ul>
}
